/* eslint-disable no-undef */
import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Link, NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Icon2Svg from "../../public/Icon_2.svg";
import Icon5Svg from "../../public/Vector_5.svg";
import aglogoSvg from "../../public/ag-new.svg";
import inflg from "../../public/inflg.svg";
import ForgotPwd3 from "../ForgotPwd3";
import MasterService from "../../services/MasterService";
import Modal from "react-modal";
import { translation } from "../../lib/utils";
export const userData = localStorage.getItem("persist:root")
  ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).userData)
  : "";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchStatus: false,
      isActive: 1,
      staticData: [
        "Ministry of Ayush",
        "Sign Out",
        "Skip to Content",
        "About India",
        "About Ministry of Ayush",
        " Global Collaborations",
        "Login / Register",
        "Dashboard",
        "LogOut",
        "Ayush Global",
        "Reset Password",
      ],
      resetModal: false,
      language: localStorage.getItem("localLang") || "en",
      languages: [
        // { label: "English", id: "en" },
        // { label: "Arabic", id: "ar" },
        // { label: "Spanish", id: "sp" },
        // { label: "Russian", id: "ru" },
        // { label: "Chinese", id: "ch" },
        // { label: "French", id: "fr" },
      ],
      query: this.props.match.params.query,
    };
  }

  componentDidMount = () => {
    this.getTranslation();
    this.getLanguages();
  };

  getLanguages = () => {
    MasterService.getLanguages()
      .then((result) => {
        if (!result) return;
        let lang = [];
        for (const prop in result.data) {
          lang.push({ label: result.data[prop], id: prop })
        }

        this.setState({ languages: lang });

      })
      .catch((err) => {
        console.error(err);
      });
  }

  getTranslation = () => {
    if (localStorage.getItem("localLang")) {
      localStorage.setItem(
        "translate",
        JSON.stringify(translation[localStorage.getItem("localLang")]),
      );
    } else {
      localStorage.setItem("localLang", "en");
      localStorage.setItem("translate", JSON.stringify(translation["en"]));
    }
  };

  logout = () => {
    localStorage.clear();
    localStorage.setItem("localLang", "en");
    window.open("/", "_self");
    this.getTranslation();
  };

  onSearch = () => {
    this.props?.history?.push({
      pathname: "/search-result/" + this.state.query,
    });
  };

  goToDashboard = () => {
    this.props?.history?.push({
      pathname:
        userData.roles === "administrator"
          ? "/super/portal-statistics"
          : userData.roles === "contributor"
            ? "/practitioner-dashboard"
            : "/mission-dashboard",
    });
  };
  onResetModal = () => {
    const { resetModal } = this.state;
    this.setState({ resetModal: !resetModal });
  };

  onSelectedLanguage = e => {
    localStorage.setItem("localLang", e.target.value);
    this.getTranslation();
    window.location.reload();
  };
  render() {
    const {
      isActive,
      staticData,
      resetModal,
      language,
      languages,
      query,
    } = this.state;

    return (
      <>
        <ToastContainer />
        {/* superadmin header */}
        <Modal
          isOpen={resetModal}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <ForgotPwd3 dismissModal={e => this.onResetModal()} type="login" />
        </Modal>
        {userData.roles === "administrator" &&
          window.location.href.match("super") ? (
          <nav className="navbar bg-body-tertiary bg-body-tertiary1 pos-fixed">
            <div className="row thrw">
              {/* <div className="thincnt">

              <div className="topheadSelect">
                <select
                  className="rgndrp_"
                  name="language"
                  id="language" aria-labelledby="language" value={language}
                  onChange={(e) => this.onSelectedLanguage(e)}
                >
                  {languages.map((item, index) => <option key={index} value={item.id}>{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</option>)}
                </select>
              </div>
            </div> */}
            </div>
            <div className="container-fluid">
              <div className="expd">
                <div className="flog">
                  <a href="https://main.ayush.gov.in/">
                    <img
                      className="img-width1 imdim"
                      src={require("../../public/image_1.png")}
                      alt="MOA logo"
                    />
                  </a>
                  <Link to="/">
                    <img
                      src={aglogoSvg}
                      className="ag-admin-logo hidehdrelm imdim"
                      alt="Ayush Global Logo"
                    />
                  </Link>
                </div>
                <div className="hidehdrelm">
                  <Link to="/">
                    <img
                      className="img-width1 imdim"
                      src={require("../../public/akampng.png")}
                      alt="logo"
                    />{" "}
                    <img
                      src={require("../../public/g20.png")}
                      className="ag-admin-logo imdim"
                      alt="Ayush Global Logo"
                    />
                  </Link>
                  {/* dropdown starting */}
                  <div className="thincnt ddmrg">
                    <div className="topheadSelect">
                      <select
                        className="rgndrp_"
                        name="language"
                        id="language"
                        aria-labelledby="language"
                        value={language}
                        onChange={e => this.onSelectedLanguage(e)}
                      >
                        {languages.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.label.charAt(0).toUpperCase() +
                              item.label.slice(1)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {/* <form className="d-flex imdim" role="search"> */}
              <div className="btn admtbtn imdim">
                <img
                  className="usrimdm rounded-circle"
                  src={require("../../public/Avatar.png")}
                  alt="Avatar"
                />
                {/* <i className="fa fa-user-circle"></i> */}
                <div className="btn-group down-arrow-btn">
                  <Link
                    className="btn btn-sm"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    to="/"
                  >
                    <img src={Icon5Svg} alt="Menu icon" />
                  </Link>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item item-flex menuitemf"
                        to="/super/portal-statistics"
                      >
                        <img
                          src={require("../../public/Avatar.png")}
                          className="avtartop rounded-circle"
                          alt="Avatar"
                        />
                        <p>
                          <span className="item301">
                            {JSON.parse(localStorage.getItem("translate"))?.moa}
                          </span>
                          <br />
                          <span className="item302">
                            {userData.user_display_name}
                          </span>
                        </p>
                      </Link>
                    </li>
                    <li>
                <div className="dropdown-divider my-1"></div>
              </li>

                    <li>
                    <span
                        className="dropdown-item item-flex menuitemf"
                        onClick={() => this.onResetModal()}
                      >
                      <i className="fa fa-cog"></i>
                      <span className="item301">
                            {
                              JSON.parse(localStorage.getItem("translate"))
                                ?.aboutIndia
                            }
                          </span>
                    </span>
                  </li>

                    {/* <li>
                      <span
                        className="dropdown-item item-flex menuitemf"
                        onClick={() => this.onResetModal()}
                      >
                        <p>
                          <span className="item301">
                            {
                              JSON.parse(localStorage.getItem("translate"))
                                ?.aboutIndia
                            }
                          </span>
                          <br />{" "}
                        </p>
                      </span>
                    </li> */}
                    <li onClick={() => this.logout()}>
                      <span className="dropdown-item item1">
                        <img src={Icon2Svg} alt="icon" />{" "}
                        <span className="margin01">
                          {
                            JSON.parse(localStorage.getItem("translate"))
                              ?.signOut
                          }
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {/* </form> */}
            </div>
          </nav>
        ) : (
          <header>
            <div className="topHeader">
              <div className="container hfl">
                <div className="row thrw">
                  <div className="thincnt">
                    <div className="fltxm">
                      <img className="" src={inflg} alt="india flag" />
                      <small className="ps-1 bg-trans-1 govtwht">
                        {" "}
                        भारत सरकार | Government of India{" "}
                      </small>
                    </div>
                    {/* <div className="dropdown county-choose">
                    <select className="rgndrp">
                      <option className="slwht" value="Region">Region</option>
                      <option value="North America">North America</option>
                      <option value="South America">South America</option>
                      <option value="Europe">Europe</option>
                      <option value="Africa">Africa and the Middle East</option>
                      <option value="South Asia">South Asia</option>
                      <option value="North Asia">North Asia</option>
                    </select>
                  </div> */}
                  </div>

                  <div className="thincnt">
                    <div className="accessbility">
                      <ul className="bg-trans-2">
                        <li>
                          <Link to="/" id="increaseFont">
                            A<sup>+</sup>
                          </Link>
                        </li>
                        <li>
                          <Link to="/" id="linkReset">
                            A
                          </Link>
                        </li>
                        <li>
                          <Link to="/" id="decreaseFont">
                            A<sup>-</sup>
                          </Link>
                        </li>
                        <li>
                          <Link to="/" id="contrast">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_2_33)">
                                <path
                                  d="M12.3854 4.98036C12.2725 4.61439 12.1231 4.26068 11.9395 3.92456C11.6681 3.4257 11.3267 2.96819 10.9258 2.56591C10.1022 1.7424 9.05289 1.1816 7.91058 0.954421C6.76826 0.727245 5.58423 0.8439 4.50822 1.28963C3.4322 1.73537 2.51251 2.49016 1.86546 3.45857C1.21841 4.42698 0.873047 5.56551 0.873047 6.7302C0.873047 7.89488 1.21841 9.03341 1.86546 10.0018C2.51251 10.9702 3.4322 11.725 4.50822 12.1708C5.58423 12.6165 6.76826 12.7331 7.91058 12.506C9.05289 12.2788 10.1022 11.718 10.9258 10.8945C11.3267 10.4922 11.6681 10.0347 11.9395 9.53583C12.1231 9.19971 12.2725 8.84601 12.3854 8.48004C12.74 7.34043 12.74 6.11996 12.3854 4.98036ZM1.71389 6.7302C1.71389 5.39149 2.24569 4.10761 3.1923 3.16099C4.13892 2.21438 5.4228 1.68258 6.76151 1.68258V11.7778C5.4228 11.7778 4.13892 11.246 3.1923 10.2994C2.24569 9.35279 1.71389 8.06891 1.71389 6.7302Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2_33">
                                  <rect
                                    width="13.4603"
                                    height="13.4603"
                                    fill="white"
                                    transform="translate(0.03125)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </Link>
                        </li>
                        <li>
                          <Link to="/" className="bg-trans-2">
                            {
                              JSON.parse(localStorage.getItem("translate"))
                                ?.skipToContent
                            }
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="topheadSelect">
                      <select
                        className="rgndrp_"
                        name="language"
                        id="language"
                        aria-labelledby="language"
                        value={language}
                        onChange={e => this.onSelectedLanguage(e)}
                      >
                        {languages.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* below is the middle navigation */}
            <div className="MiddleHeader">
              <div className="container">
                <div className="row mt-4 mb-2">
                  <div className="d-flex align-items-center m-flex jspb top-logos">
                    {/* below is the left side logos */}
                    <div className="leftlogocont">
                      <a href="https://main.ayush.gov.in/">
                        <img
                          src={require("../../public/image_1.png")}
                          alt="ministry of ayush logo"
                        />
                        <span style={{ display: "none" }}>moa logo</span>
                      </a>
                      <Link to="/">
                        <img src={aglogoSvg} alt="Ayush Global Logo" />
                        <span style={{ display: "none" }}>agp logo</span>
                      </Link>
                    </div>

                    {/* below is the search bar */}
                    <div className="srchbarcont">
                      <form className="d-flex fcnt hdfr" role="search">
                        <div
                          className="icnt"
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <input
                            aria-label="search"
                            style={{
                              borderRadius: "10px 0 0 10px",
                              height: "100%",
                            }}
                            type="text"
                            className="form-control"
                            id="portalsearch"
                            value={query}
                            onChange={e =>
                              this.setState({ query: e.target.value })
                            }
                            onKeyDown={e =>
                              e.key === "Enter" && this.onSearch()
                            }
                            placeholder="Type here to search"
                          />
                          <button
                            type="button"
                            value="search"
                            onClick={() => this.onSearch()}
                            aria-label="search"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "15px 20px",
                              background: "#F19755",
                              color: "white",
                              fontWeight: "500",
                              borderRadius: "0 10px 10px 0",
                              textDecoration: "none",
                              border: "none",
                              height: "100%",
                            }}
                          >
                            <svg
                              style={{ strokeWidth: "8px" }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                            </svg>
                          </button>
                        </div>
                      </form>
                    </div>

                    {/* below is the right side logos */}
                    <div className=" rightlogocont">
                      {/* <Link to='/'> */}
                      <a href="https://amritmahotsav.nic.in/">
                        <img
                          src={require("../../public/akampng.png")}
                          className="img-fluid grid-logo akamwd"
                          alt="amrit mahotsav logo"
                        />
                        <span style={{ display: "none" }}>akam logo</span>
                      </a>
                      {/* </Link> */}
                      {/* <Link to='/'> */}
                      <a href="https://g20.mygov.in/">
                        <img
                          src={require("../../public/g20.png")}
                          className="img-fluid grid-logo akamwd"
                          alt="g20 india logo"
                        />
                        <span style={{ display: "none" }}>g20 logo</span>
                      </a>
                      {/* </Link> */}
                    </div>
                  </div>
                  <div className="row py-2">
                    <div className="col-12 text-end"></div>
                  </div>
                </div>
              </div>
              {/* below is the second navigation */}

              <nav className="navbar navbar-expand-lg scnvcl main-nav">
                <div className="container">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <form className="d-flex fcnt scndform" role="search">
                    <div
                      className="icnt"
                      style={{ display: "flex", alignItems: "flex-start" }}
                    >
                      <input
                        aria-label="search"
                        style={{
                          borderRadius: "10px 0 0 10px",
                          height: "100%",
                        }}
                        type="text"
                        className="form-control"
                        id="portalsearch"
                        placeholder="Type here to search"
                      />
                      <button
                        type="button"
                        value="search"
                        aria-label="search"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "15px 20px",
                          background: "#F19755",
                          color: "white",
                          fontWeight: "500",
                          borderRadius: "0 10px 10px 0",
                          textDecoration: "none",
                          border: "none",
                          height: "100%",
                        }}
                      >
                        <svg
                          style={{ strokeWidth: "8px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                      </button>
                    </div>
                  </form>

                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                      <li
                        className={
                          isActive === "1"
                            ? "nav_selected nav-item"
                            : "nav-item"
                        }
                      >
                        <NavLink
                          activeClassName="item_selected"
                          onClick={() => this.setState({ isActive: "1" })}
                          className="dropdown-item"
                          to="/"
                          aria-label="homepage"
                        >
                         Home
                          <span className="hdn">home Nav</span>
                        </NavLink>
                      </li>
                      <li
                        className={
                          isActive === "2"
                            ? "nav_selected nav-item"
                            : "nav-item"
                        }
                      >
                        <NavLink
                          activeClassName="item_selected"
                          onClick={() => this.setState({ isActive: "2" })}
                          className="dropdown-item"
                          to="/ayush-global"
                        >
                          {
                            JSON.parse(localStorage.getItem("translate"))
                              ?.ayushGlobal
                          }
                        </NavLink>
                      </li>

                      <li
                        className={
                          isActive === "3"
                            ? "nav_selected nav-item"
                            : "nav-item"
                        }
                      >
                        <NavLink
                          activeClassName="item_selected"
                          className="dropdown-item"
                          onClick={() => this.setState({ isActive: "3" })}
                          to="/about-india"
                        >
                          {
                            JSON.parse(localStorage.getItem("translate"))
                              ?.aboutIndia
                          }
                        </NavLink>
                      </li>
                      <li
                        className={
                          isActive === "4"
                            ? "nav_selected nav-item"
                            : "nav-item"
                        }
                      >
                        <NavLink
                          activeClassName="item_selected"
                          className="dropdown-item"
                          onClick={() => this.setState({ isActive: "4" })}
                          to="/about-us"
                        >
                          {
                            JSON.parse(localStorage.getItem("translate"))
                              ?.aboutMoa
                          }
                        </NavLink>
                      </li>
                      <li
                        className={
                          isActive === "5"
                            ? "nav_selected nav-item"
                            : "nav-item"
                        }
                      >
                        <NavLink
                          activeClassName="item_selected"
                          className="dropdown-item"
                          onClick={() => this.setState({ isActive: "5" })}
                          to="/global-collab"
                        >
                          {
                            JSON.parse(localStorage.getItem("translate"))
                              ?.globalCollab
                          }
                        </NavLink>
                      </li>
                      <li
                        className={
                          isActive === "6"
                            ? "nav_selected nav-item"
                            : "nav-item"
                        }
                      >
                        <NavLink
                          activeClassName="item_selected"
                          className="dropdown-item"
                          onClick={() => this.setState({ isActive: "6" })}
                          to="/status-in-india"
                        >
                          {
                            JSON.parse(localStorage.getItem("translate"))
                              ?.statusInIndia
                          }
                        </NavLink>
                      </li>
                    </ul>
                    <form className="d-flex" role="search">
                      <ul
                        className="actionMenu"
                        style={{ display: "flex", gap: "8px" }}
                      >
                        {userData.token ? (
                          <></>
                        ) : (
                          <Link
                            to="/login"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "2px 14px",
                              background: "#00A88A",
                              color: "white",
                              fontWeight: "500",
                              borderRadius: "5px ",
                              textDecoration: "none",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-box-arrow-in-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                              />
                              <path
                                fillRule="evenodd"
                                d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                              />
                            </svg>
                            <p
                              style={{
                                margin: "0",
                                padding: "0",
                                fontSize: "13px",
                              }}
                              className="bg-trans-2"
                            >
                              {
                                JSON.parse(localStorage.getItem("translate"))
                                  ?.loginRegister
                              }
                            </p>
                          </Link>
                        )}
                      </ul>
                      {userData.token ? (
                        <div
                          className="dropdown"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "4px 9px",
                            borderRadius: "5px",
                            color: "#9f9f9f",
                          }}
                        >
                          <div
                            className="userimg"
                            style={{
                              borderRadius: "100%",
                              border: "1px solid black",
                              backgroundImage: `url(${userData.user_img})`,
                              backgroundPosition: "center",
                              height: "40px",
                              width: "40px",
                              backgroundSize: "contain",
                            }}
                          ></div>
                          <div>
                            <button
                              className="btn  dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              style={{
                                background: "none",
                                border: "none",
                                color: "#393939",
                                paddingLeft: "0",
                                paddingRight: "0",
                                fontWeight: "600",
                              }}
                            >
                              {userData.user_display_name}
                            </button>
                            <ul
                              className="dropdown-menu logindrop"
                              id="dropdown-menu"
                              aria-labelledby="dropdown-menu"
                            >
                              <li>
                                <span
                                  className="dropdown-item"
                                  onClick={() => this.goToDashboard()}
                                >
                                  <span>
                                    {
                                      JSON.parse(
                                        localStorage.getItem("translate"),
                                      )?.dashboard
                                    }
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span
                                  className="dropdown-item  "
                                  onClick={() => this.onResetModal()}
                                >
                                  <p>
                                    <span>
                                      {
                                        JSON.parse(
                                          localStorage.getItem("translate"),
                                        )?.resetPwd
                                      }
                                    </span>
                                    <br />{" "}
                                  </p>
                                </span>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to="/"
                                  onClick={() => this.logout()}
                                >
                                  <span>
                                    {
                                      JSON.parse(
                                        localStorage.getItem("translate"),
                                      )?.signOut
                                    }
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </form>
                  </div>
                </div>
              </nav>
            </div>
          </header>
        )}
      </>
    );
  }
}

export default compose(connect(null, null), withRouter)(Header);
